import ApplicationSerializer from './application';

export default class SignInFieldActionSerializer extends ApplicationSerializer {
  attrs = {
    operation: { serialize: false },
  };
}
